<template>
  <div class="loginContainer">
    <div class="contents">
      <img
        src="../../assets/img/login/LOG.png"
        alt=""
        style="width:267px;vertical-align:middle;cursor:pointer;margin-left:120px;"
        @click="matinTap"
      />
    </div>
    <div class="backgs">
      <div :class="this.widthwin>1000?'logincontain':'logincontain logincontains'">
        <div class="accout">{{$t('user.accout')}}</div>
        <div class="accoutnum">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            :rules="rule"
            class="demo-ruleForm"
          >
            <div class="content">
              <div class="formLeft">
                <el-form-item prop="phone">
                  <el-input
                    :placeholder="$t('user.name')"
                    v-model="ruleForm.phone"
                  >
                    <i
                      slot="prefix"
                      class="el-input__icon el-icon-user"
                    ></i>
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="content">
              <div class="formLeft">
                <el-form-item prop="password">
                  <el-input
                    :placeholder="$t('user.password')"
                    v-model="ruleForm.password"
                    :type="myType"
                     @keyup.enter.native="bindLogin('ruleForm')"
                  >
                    <i
                      slot="prefix"
                      class="el-input__icon el-icon-lock"
                    ></i>
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div class="box_checkbox">
          <div>
            <el-checkbox
              v-model="checked"
              @change="checkchange"
            ><span style="font-size:14px;">{{$t('user.checked')}}</span>
            </el-checkbox>
          </div>
          <div>
            <span
              style="font-size:14px;text-align:right;color: #fff;opacity: 0.5;"
              @click="forgetCode"
            >{{$t('user.forgetCode')}}</span>
          </div>
        </div>
        <div class="btn-check">
          <el-button
            type="success"
            style="width:280px;"
            @click="bindLogin('ruleForm')"
          >{{$t('user.login')}}</el-button>
        </div>
        <div class="regUser">
          <span>{{$t('user.regUser')}}</span>
          <span
            class="signsty"
            style="font-size:14px;cursor:pointer;color: #009c53;"
            @click="tapSign"
          >{{$t('user.signsty')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var phonevalid = (rule, value, callback) => {
      if (value == 0) {
        return callback(new Error(this.$t('checkvalid.account')));
      } else {
        callback();
      }
    };
    var loginPass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (!rest.test(value) || !value || value < 6 || value > 20) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        phone: "",
        password: ""
      },
      rule: {
        phone: [{ required: true, validator: phonevalid, trigger: "blur" }],
        password: [{ required: true, validator: loginPass, trigger: "blur" }]
      },
      eyeStatus: false,
      checked: true,
      shows: false,
      widthwin:""
    };
  },
  computed: {
    myType: function() {
      return this.eyeStatus == false ? "password" : "";
    }
  },
  mounted(){
      this.widthwin = document.body.clientWidth || document.documentElement.clientWidth;
    console.log(this.widthwin)
  },
  methods: {
    eyeTap() {
      this.eyeStatus = true;
    },
    checkchange() {
      if (this.checked == true) {
        this.checked == false;
      } else {
        this.checked == true;
      }
    },
    userInfo() {
      const data = {
        token: this.$store.state.token
      };
      this.$http
        .post("/user/get_me", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              console.log(res.data);
              this.$store.state.userName = res.data.data.name;
              window.sessionStorage.setItem("userName", res.data.data.name);
              if(this.$route.query.type) {
                 this.$router.push({
                  name: "price"
                });
              } else {
                this.$router.push({
                  name: "main"
                });
              }
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    bindLogin(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          const data = {
            account: this.ruleForm.phone,
            password: this.ruleForm.password
          };
          this.$http
            .post("/login/login", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  // 先进行本地存储
                  console.log(res.data);
                  this.$store.commit("loginIn", res.data.data.token);
                  sessionStorage.setItem("token", res.data.data.token);
                  this.$message({
                    message: this.$t('checkvalid.logins'),
                    type: "success",
                    duration: 1000
                  });
                  this.userInfo();
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    matinTap() {
      this.$router.push({
        name: "main"
      });
    },
    tapSign() {
      this.$router.push({
        name: "sign"
      });
    },
    forgetCode() {
      this.$router.push({
        name: "forgetPsd"
      });
    },
    mouseOver() {
      this.shows = true;
    },
    mouseMove() {
      this.shows = false;
    },
    handleLanguage() {
      console.log(2222);
    }
  }
};
</script>
<style lang="scss">
.loginContainer {
  width: 100%;
  height: 100%;
  position: absolute;
  background: url("../../assets/img/login/banner.png") no-repeat center center;
  background-size: 100% 100%;
  // 头部
  .contents {
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    background: url("../../assets/img/login/header.png") no-repeat center center;
    background-size: cover;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: left;
    .el-dropdown-link {
      cursor: pointer !important;
      font-size: 14px !important;
    }
    .chiese {
      height: 50px;
      line-height: 50px;
      display: inline-block;
      cursor: pointer;
    }
    .user_in {
      cursor: pointer;
      min-width: 84px;
      display: block;
      position: absolute;
      top: 50px;
      right: 30px;
      padding: 0;
      margin: 0;
      z-index: 999999;
      background: #efeeeb;
      opacity: 0.9;
      border: none;
      border-radius: 4px;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      span {
        margin: 0;
        padding: 0 10px;
      }
      span:hover {
        color: #248f47;
      }
    }
  }
  .backgs {
    width: 100%;
    // height: 100%;
    // position: relative;
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #009c53;
      border-color: #009c53;
    }
    .el-checkbox__label {
      span {
        color: #fff !important;
        opacity: 0.5;
      }
    }
    .logincontain.logincontains{
      right: 3% !important;
    }
    .logincontain {
      width: 374px;
      height: 420px;
      background: url("../../assets/img/login/loginborder.png") no-repeat center
        center;
      background-size: 100% 100%;
      position: absolute;
      top: 25%;
      right: 10%;
      .el-form-item {
        margin-bottom: 40px;
      }
      .el-form-item__error {
        left: 9px;
      }
      .accout {
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: #fff;
      }
      .accoutnum {
        margin: 30px 0 20px 0;
        padding: 0 20px;
      }
      .box_checkbox {
        display: flex;
        justify-content: space-between;
        padding: 0 30px 0 30px;
        height: 40px;
        // line-height: 40px;
        margin-bottom: 15px;
        span {
          cursor: pointer;
          color: #606266;
        }
        span:hover {
          color: #248f47;
        }
      }
      .regUser {
        margin-top: 20px;
        color: #fff;
        opacity: 0.5;
        .signsty:hover {
          color: #1d5a33;
        }
      }
      .el-input__inner {
        background-color: #788c91;
        box-shadow: 0px 4px 9px 1px rgba(29, 90, 51, 0.2);
      }
      .el-input__inner:focus {
        border-color: #dcdfe6;
      }
      .el-input__inner {
        color: #fff;
      }
    }
  }
}
</style>
